import {useMutation} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import axiosManager from "../services/axiosManager";
import {useToast} from "../context/toast";

export const useCreateApplication = () => {
    const {t} = useTranslation();
    const toast = useToast();

    const {
        mutateAsync: createApplication, isPending: isCreatingApplication,
    } = useMutation({
        mutationFn: () => axiosManager.post$("applications", null).then((response) => response?.data),
        onError: () => {
            toast.error(t("errors.common"));
        },
    });

    return {
        createApplication,
        isCreatingApplication,
    };
};
